export const DNS = 'DNS'